module.exports = {
    "dev" : {
        // baseUrl:"https://servicesv1.nyggs.com:82"
        // baseUrl:"https://nkcsso.nyggs.com:75/api/"
        baseUrl:"https://demosso.nyggs.com/backend/hrms/api/"
        // baseUrl:"http://192.168.30.53:81"
    },
    "prod" : {
        // baseUrl:"https://mmshawl.nyggs.com:81"
        // baseUrl:"https://nkcsso.nyggs.com:75/api/"
        baseUrl:"https://demosso.nyggs.com/backend/hrms/api/"
        // baseUrl:"http://192.168.200.27:81"
    }   
}